import React from "react";
import { ErrorPage } from "./pages";
import { useLocation } from 'react-router-dom';

class ErrorBoundaryInner extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidUpdate(prevProps) {
    if (this.props.location && prevProps.location && this.props.location.pathname !== prevProps.location.pathname) {
      if (this.state.hasError) {
        this.setState({ hasError: false });
      }
    }
  }

  render() {
    if (this.state.hasError) {
      return <ErrorPage onReset={() => this.setState({ hasError: false })} />;
    }
    return this.props.children;
  }
}

export default function ErrorBoundary(props) {
  const location = useLocation();
  return <ErrorBoundaryInner {...props} location={location} />;
}
